//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CatalogSidebar from './Sidebar'
import CatalogContent from './Content'

export default {
  components: { CatalogSidebar, CatalogContent },
  props: [
    'result',
    'loading',
    'receive',
    'parameters',
    'filters',
    'changeFilters',
    'pagination',
    'changePagination',
    'attributesResource',
    'availableAttributesResource',
    'label',
    'sortlist',
    'filterComponent',
    'initial',
    'showFilters',
  ],
  data() {
    return {
      filtersChanged: false,
    }
  },

  watch: {
    result: {
      handler() {
        if (!this.result.meta) return
        const h1 = document.getElementById('main-title')
        if (h1) {
          h1.innerHTML = this.result.meta.h1
        }
      },
      deep: true,
    },
  },

  created() {
    // this.search()
  },

  methods: {
    search() {
      this.receive(this.parameters)
    },
  },
}

